const isMobile = {
  Android: function () {
    return navigator.userAgent.match(/Android/i);
  },
  BlackBerry: function () {
    return navigator.userAgent.match(/BlackBerry/i);
  },
  Opera: function () {
    return navigator.userAgent.match(/Opera Mini/i);
  },
  Windows: function () {
    return navigator.userAgent.match(/IEMobile/i);
  },
  iOS: function () {
    return (navigator.userAgent.match(/iPhone|iPad|iPod/i) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) &&
      !window.MSStream;
  },
  any: function () {
    return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
  }
};

const browserDetect = () => {
  let userAgent = navigator.userAgent;
  let browserName;

  if (userAgent.match(/chrome|chromium|crios/i)) {
    browserName = "chrome";
  } else if (userAgent.match(/firefox|fxios/i)) {
    browserName = "firefox";
  } else if (userAgent.match(/safari/i)) {
    browserName = "safari";
  } else if (userAgent.match(/opr\//i)) {
    browserName = "opera";
  } else if (userAgent.match(/edg/i)) {
    browserName = "edge";
  }

  document.documentElement.classList.add(browserName);
}

const getScript = (url, callback) => new Promise((resolve, reject) => {
  const script = document.createElement('script')
  script.src = url
  script.async = true

  script.onerror = reject

  script.onload = script.onreadystatechange = function () {
    const loadState = this.readyState

    if (loadState && loadState !== 'loaded' && loadState !== 'complete') return

    script.onload = script.onreadystatechange = null

    if (typeof callback === 'function') {
      callback();
    }

    resolve()
  }

  document.head.appendChild(script)
})

// Плавный скролл до элемента
const setSmoothScroll = (elementID) => {
  const element = document.querySelector(elementID);
  const headerTopBlock = document.querySelector('.header__top-block');

  if (element) {
    const topOffset = (headerTopBlock) ? headerTopBlock.clientHeight : 0;
    const elementPosition = element.offsetTop;
    const offsetPosition = elementPosition - topOffset;
    window.scrollTo({top: offsetPosition, behavior: 'smooth'});
  }
}

// Устанавливает шапку на всю высоту на главной
const setHeightHeaderMain = () => {
  const headerMainPage = document.querySelector('.page--main .header');

  if (!headerMainPage) return;

  const windowOuterHeight = window.outerHeight;
  const windowInnerHeight = window.innerHeight;
  const sliderOnMain = document.querySelector('.header__slider');
  const videoOnMain = document.querySelector('.header__video');
  const video = document.querySelector('.video');
  const searchForm = headerMainPage.querySelector('.search-form');

  if (windowOuterHeight >= 670) {
    if (sliderOnMain || videoOnMain) {
      headerMainPage.style.height = windowInnerHeight + 'px';
      searchForm.style.position = 'absolute';

      if (sliderOnMain) {
        sliderOnMain.style.height = windowInnerHeight + 'px';
      }

      if (videoOnMain) {
        videoOnMain.style.height = windowInnerHeight + 'px';
        video.style.maxHeight = windowInnerHeight + 'px';
      }
    }
  } else {
    headerMainPage.style.height = null;
    searchForm.style.position = 'static';
    if (sliderOnMain) {
      sliderOnMain.style.height = null;
    }

    if (videoOnMain) {
      videoOnMain.style.height = null;
      video.style.maxHeight = null;
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  browserDetect();
  /*setHeightHeaderMain();
  if (isMobile.any()) {
    window.addEventListener("orientationchange", setHeightHeaderMain);
  } else {
    window.addEventListener("resize", setHeightHeaderMain);
  }*/
});

export {isMobile, getScript, setSmoothScroll};
